import React, { useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { DelayInput } from "react-delay-input/lib/Component";
import DatePicker from "../datePicker/DatePicker";
import {
  getEndOfDayFromDate,
  getStartOfDayFromDate,
  TimestampToDate
} from "../../../utils/timestampToDate";
import Dropdown from "rc-dropdown";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper, StyledSelectGroup,
  StyledShowFilterBtn
} from "../filter/styledFiter";
import { StyledDatepicker } from "../../styles/styledDatepicker";
import ServicesSelect from "../services/ServicesSelect";

const ServiceLogsFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("logsPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "ip": "",
    "user": "",
    "transactionId": "",
    "datetime[gte]": "",
    "datetime[lte]": "",
    "collection": filterData["collection"] ?? null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="transactionId"> {t("filter.transactionId")}</label>
              <DelayInput
                id="transactionId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "transactionId": event.target.value, page: 1 })}
                name="transactionId"
                value={filterData["transactionId"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="user">E-mail</label>
              <DelayInput
                id="user"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "user": event.target.value, page: 1 })}
                name="user"
                value={filterData["user"]}
                type="text"
              />
            </StyledFilterGroup>
            <StyledSelectGroup>
              <ServicesSelect
                checkedService={filterData["collection"] ? filterData["collection"].replace("Logs", "") : null}
                setCheckedService={(data) => setFilterData({ ...filterData, "collection": data + "Logs", page: 1 })}
                isObject={false}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("filter.dateFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "datetime[gte]": getStartOfDayFromDate(dateFrom),
                  page: 1
                })}
                value={TimestampToDate(filterData["datetime[gte]"])}
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("filter.dateTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "datetime[lte]": getEndOfDayFromDate(dateTo),
                  page: 1
                })}
                value={TimestampToDate(filterData["datetime[lte]"])}
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ServiceLogsFilter;